import React, { useEffect, useState } from "react";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../../environment/BackendService";
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad,
} from "../../../../common_nextgen/utils/UtilFunctions";

const useStateList = (
  onSelect,
  hideModal,
  initialSelectParams,
  initialLookupType,
  selectModeParamData = {}
) => {
  const [data, setData] = useState([]); /* State List Data */
  const { axios_helper_no_header } = useAxios();
  const [paramsData, setParamsData] = useState({
    searchCriteria: selectModeParamData.searchCriteria ?? "",
  }); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const toast = useToast();
  const location = useLocation();
  const {} = ROUTE_PATHS;

  const screen_title = "State List";
  const screenNumber = "RCSTL005";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "STL State List Name",
      name: "searchCriteria",
      label: "List",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (lookupType === "external") {
          // hideModal();
          const message = {
            type: "hideModal",
          };
          window.parent.postMessage(message, "*");
        } else {
          hideModal();
        }
      },
      button_key: "F12",
    },
  ];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    // {
    //   button_label: "Add State List",
    //   button_handeler: () => {
    //     navigateToPage(ADD_STATE_LIST);
    //   },
    //   button_key: "F6",
    // },
    // {
    //   button_label: "Export as CSV",
    //   button_handeler: () => {
    //     exportAsCSV();
    //   },
    //   button_key: "",
    // },
    // {
    //   button_label: "Back",
    //   button_handeler: () => {
    //     navigateToPage(DISPLAY_STATE_LIST);
    //   },
    //   button_key: "F12",
    // },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: () => {
        const paramDataMap = new Map();
        selectParams.forEach((key) => {
        if (rowData.hasOwnProperty(key["target"])) {
          paramDataMap.set(key["source"], rowData[key["target"]]);
        }
      });
        const paramData = Object.fromEntries(paramDataMap);
        if (lookupType === "local") {
          onSelect(paramData);
        } else {
          const message = {
            type: "responseData",
            data: paramData,
          };
          window.parent.postMessage(message, "*");
        }
      },
    },
  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "List",
      field: "list",
    },
    {
      header: "Description",
      field: "description",
    },
  ];

  /* Param Key which used as bridge between various operations on tabular data */
  const parmKey = "list";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rcstlp`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData } = data;

      setLookupType("external");
      setSelectParams(paramData.params);
      setParamsData({
        ...paramsData,
        searchCriteria: paramData.paramsData?.searchCriteria || "",
      });
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, selectedOption, lookupType]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rcstlp/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    setSelectedOption,
    leftButtons,
  };
};

export default useStateList;
